module.exports = __webpack_public_path__ + "static/media/pga_request.45d53389.png";